/**
 * Frases com o nome do setor.
 *
 * Até a v2 os cinco setores eram fixos e dava para saber o gênero de cada
 * nome ("no Corte", "na Furação"). Agora o gestor batiza a sala como quiser
 * ("Coladeira", "Galpão 2", "Bancada do fundo") e adivinhar artigo pelo nome
 * erraria em português — "na Galpão 2". Então o substantivo é sempre `setor`,
 * que tem gênero conhecido, e o nome vem depois: "no setor Coladeira".
 */

const SEM_NOME = "setor";

const comNome = (preposicao, nome) => {
  const limpo = String(nome ?? "").trim();
  return limpo ? `${preposicao} setor ${limpo}` : `${preposicao} ${SEM_NOME}`;
};

/** "no setor Corte". */
export function noSetor(nome) {
  return comNome("no", nome);
}

/** "do setor Corte". */
export function doSetor(nome) {
  return comNome("do", nome);
}
